<template>
    <div class="animated fadeIn container page-content">
        <SectionTitle :title="'Giới thiệu'" />
        <div class="quillWrapper">
            <div class="ql-snow">
                <div
                    id="html-content"
                    class="ql-editor content"
                    style="display: flow-root"
                    v-html="aboutContent.content"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle';
import { mapActions } from 'vuex';

export default {
    components: {
        SectionTitle
    },
    data() {
        return {
            aboutContent: {
                content: ''
            }
        };
    },
    async mounted() {
        this.aboutContent = await this.getNewsInfo({ id: 17 });
    },
    methods: {
        ...mapActions({
            getNewsInfo: 'news/getInfo'
        })
    }
};
</script>
<style lang="scss">
@media screen and (min-width: 1025px) {
    .page-content {
        padding: 0px 120px;
    }
}
@media screen and (max-width: 500px) {
    .page-content {
        padding: 0px;
        .fit-page-row {
            margin: 0px !important;
            .fit-page-col {
                padding: 0px !important;
            }
        }
    }
}
.content > p {
    font-size: 13pt;
}
</style>
